import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { EventDateList } from '../SiteClasses';
import { timeConverter } from '../SiteUtil';
import API from '../API';

var SearchEventModal = (props: SearchCoreProps<EventDateList>)=>{
	return <SearchCoreModal
		title='Buscar Evento'
		{...props}
		searchData={(query, page, page_size)=>{
			return API.searchEvents(query, page * page_size, page_size);
		}}
		pageSize={10}
		table={[
			{ name: 'Evento', key: 'date_id', collapsing: true },
			{ name: 'Nombre', key: 'event_name', collapsing: true },
			{ name: 'Fecha', key: 'date', collapsing: true, render: timeConverter },
		]}
	/>
}

export default SearchEventModal;